const DOM = {};
let bgCounter = 1;
let bgTimer;

const cacheDOM = () => {
    DOM.homeSlider = document.querySelector('.banner__bg-slider');
    DOM.homeBackground = document.querySelector('.banner__background');
    DOM.backgroundList = document.querySelectorAll('.banner__bg-image');
    DOM.slidesList = document.querySelectorAll('.banner__bg-option');
    DOM.slideVideo = document.querySelector('.banner__bg-image video');
};

const slideToOption = (option) => {
    DOM.slidesList.forEach((slide) => {
        slide.classList.remove('banner__bg-option--active');
    });

    DOM.backgroundList.forEach((bg) => {
        bg.classList.remove('banner__bg-image--active');
        if (option.dataset.slide === bg.dataset.background) {
            bg.classList.add('banner__bg-image--active');
            clearInterval(bgTimer);
            if (!bg.firstElementChild) {
                bgTimer = setInterval(nextSlide, 5000);
            } else {
                bg.firstElementChild.play();
            }
        }
    });
    option.classList.add('banner__bg-option--active');
};

const nextSlide = () => {
    const activeElement = document.querySelector('.banner__bg-option--active');
    const nextOpt =
        activeElement.nextElementSibling != null
            ? activeElement.nextElementSibling
            : activeElement.parentElement.firstElementChild;

    slideToOption(nextOpt);
};

const handleMousedown = (e) => {
    if (e.target.classList.contains('banner__bg-option')) {
        slideToOption(e.target);
    }
};

const handleVideoEnd = () => {
    const videoContainer = DOM.slideVideo.parentElement;
    if (videoContainer.classList.contains('banner__bg-image--active')) {
        if (DOM.homeBackground.children.length > 1) {
            nextSlide();
        } else {
            DOM.slideVideo.play();
        }
    }
};

const bindEvents = () => {
    DOM.homeSlider.addEventListener('mousedown', handleMousedown);
    if (DOM.slideVideo) {
        DOM.slideVideo.addEventListener('ended', handleVideoEnd);
    }
};

const init = () => {
    cacheDOM();

    // Lazyload and add breakpoints to videos
    const video = document.querySelector('video[data-src][data-mobile-src]');
    if (video) {
        const mq = window.matchMedia('(min-width: 768px)');

        const manageVideo = (ev) => {
            const currentSource = video.getAttribute('src');
            const url = ev.matches
                ? video.dataset.src
                : video.dataset.mobileSrc;

            if (currentSource !== url) {
                video.setAttribute('src', url);
                video.play();
            }
        };

        mq.addListener(manageVideo);
        manageVideo(mq);
    }

    if (DOM.homeSlider && DOM.backgroundList.length > 1) {
        DOM.backgroundList.forEach(() => {
            const newOption = document.createElement('div');
            newOption.classList.add('banner__bg-option');
            newOption.dataset.slide = bgCounter;

            if (bgCounter === 1) {
                newOption.classList.add('banner__bg-option--active');
            }

            DOM.homeSlider.appendChild(newOption);
            DOM.slidesList = document.querySelectorAll('.banner__bg-option');
            bgCounter += 1;
        });

        bgTimer = setInterval(nextSlide, 5000);
        bindEvents();
        if (
            DOM.slideVideo &&
            DOM.homeBackground.firstElementChild.firstElementChild ===
                DOM.slideVideo
        ) {
            DOM.slideVideo.play();
        }
    } else if (DOM.backgroundList.length === 1 && DOM.slideVideo) {
        DOM.slideVideo.play();
        DOM.slideVideo.addEventListener('ended', handleVideoEnd);
    }
};

const homeSlider = { init };
export default homeSlider;
